import ContainerCustom from "../../../Components/ContainerCustom";
import PhaseContainer from "./PhaseContainer";

export default function PhaseInfoContainer({
  header,
  headSVG,
  phaseData = {},
}) {
  return (
    <PhaseContainer header={header} headSVG={headSVG}>
      <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">تعداد روز</p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.duration}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            درصد سود هدف
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.phase_type !== "funded"
              ? phaseData?.profit_target
              : "نامحدود"}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark text-nowrap">
            درصد درادان کلی
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.max_drawdown_limit}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            درصد درادان روزانه
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.daily_drawdown_limit}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            درصد درادان معامله
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.trade_drawdown_limit}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حداقل روزهای معاملاتی
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.phase_type !== "funded"
              ? phaseData?.trading_days_min
              : "-"}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حداکثر تعداد معامله و سفارش باز
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.max_open_positions}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            نگهداری معامله و سفارش طی روز
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.hold_daily ? "مجاز" : "مجاز نیست"}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            نگهداری معامله و سفارش طی هفته
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.hold_weekend ? "مجاز" : "مجاز نیست"}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حداکثر ثانیه اسکلپ
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            30
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حداکثر درصد مجاز سود اسکلپ
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.fast_scalp ? "بدون محدودیت" : "10"}
          </p>
        </div>
        <div className="flex justify-between items-center py-3 gap-10">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            حداکثر درصد مجاز سود هر معامله از کل{" "}
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            {phaseData?.consistency_rule ? "بدون محدودیت" : "20"}
          </p>
        </div>
      </article>
    </PhaseContainer>
  );
}
